import { Button, TextField, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import HomeIcon from "@material-ui/icons/Home";
import PrintIcon from "@material-ui/icons/Print";

const initialPackageCounts = {
  All: 0,
  Ready: 0,
  Printed: 0,
  Packed: 0,
  Scanned: 0,
};
const OrderPackagesHeader = ({
  onFilterChange,
  packages,
  selectedPackages,
  handlePrintLabels,
  onSearchTermFilterChange,
}) => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [packageCounts, setPackageCounts] = useState(initialPackageCounts);
  const history = useHistory();

  const goToHome = () => {
    history.push("/home");
  };
  // Calculate package counts whenever the packages array changes
  useEffect(() => {
    if (!packages || packages.length === 0) {
      setPackageCounts(initialPackageCounts);
      return;
    }

    // Use reduce to count packages by status in a single pass
    const counts = packages.reduce(
      (acc, pkg) => {
        if (pkg.status.includes("Ready")) {
          acc.Ready++;
        } else if (pkg.status === "Printed") {
          acc.Printed++;
        } else if (pkg.status === "Packed") {
          acc.Packed++;
        } else if (pkg.status === "Scanned") {
          acc.Scanned++;
        }
        return acc;
      },
      {
        All: packages.length,
        Ready: 0,
        Printed: 0,
        Packed: 0,
        Scanned: 0,
      }
    );

    setPackageCounts(counts);
  }, [packages]);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);
    if (onFilterChange) {
      onFilterChange(filter);
    }
  };
  // Define background colors for active states based on badge colors
  const activeBackgroundColors = {
    All: "bg-gray-100",
    Ready: "bg-blue-50",
    Printed: "bg-yellow-50",
    Packed: "bg-green-50",
    Scanned: "bg-purple-50",
  };

  // Define badge colors
  const badgeColors = {
    All: "bg-gray-200",
    Ready: "bg-blue-500 text-white",
    Printed: "bg-yellow-500 text-white",
    Packed: "bg-green-500 text-white",
    Scanned: "bg-purple-500 text-white",
  };

  // Define text colors for active states based on badge colors
  const activeTextColors = {
    All: "#4b5563", // gray-600
    Ready: "#2563eb", // blue-600
    Printed: "#d97706", // yellow-600
    Packed: "#16a34a", // green-600
    Scanned: "#9333ea", // purple-600
  };

  const renderFilterItem = (label) => {
    const isActive = activeFilter === label;

    // Create a proper className string with conditional active class
    let className = "cursor-pointer px-3 py-1 rounded-md hover:bg-slate-100";

    // Add the active background color class if this filter is active
    if (isActive) {
      className += ` ${activeBackgroundColors[label]}`;
    }

    // Style object for both background color and text color
    const itemStyle = isActive
      ? {
          backgroundColor: getBackgroundColorFromClass(
            activeBackgroundColors[label]
          ),
          fontWeight: 600,
        }
      : {};

    // Style object specifically for the text
    const textStyle = isActive
      ? {
          color: activeTextColors[label],
        }
      : {};

    return (
      <div
        className={className}
        onClick={() => handleFilterClick(label)}
        style={itemStyle}
      >
        <Typography style={textStyle}>
          {label}{" "}
          <span
            className={`ml-1 inline-flex items-center justify-center w-5 h-5 ${badgeColors[label]} rounded-full text-xs font-medium`}
          >
            {packageCounts[label]}
          </span>
        </Typography>
      </div>
    );
  };

  const getBackgroundColorFromClass = (className) => {
    switch (className) {
      case "bg-gray-100":
        return "#f3f4f6";
      case "bg-blue-50":
        return "#eff6ff";
      case "bg-yellow-50":
        return "#fefce8";
      case "bg-green-50":
        return "#f0fdf4";
      case "bg-purple-50":
        return "#faf5ff";
      default:
        return "transparent";
    }
  };

  return (
    <header className="bg-white shadow-sm z-10">
      <div className="p-4">
        <div className="flex items-center justify-between mb-4">
          <>
            <div className="flex items-center gap-4">
              <HomeIcon className=" mr-3 cursor-pointer" onClick={goToHome} />
              <Typography
                className="text-2xl font-semibold text-slate-800"
                style={{ borderLeft: "1px solid #c4c4c4", paddingLeft: 20 }}
              >
                Packages
              </Typography>
            </div>
          </>

          <TextField
            label="Search Packages"
            variant="outlined"
            size="small"
            placeholder={"Search Packages..."}
            onChange={(e) => onSearchTermFilterChange(e.target.value)}
          />
        </div>
        <div className="flex items-center justify-between">
          <div className="flex gap-4">
            {renderFilterItem("All")}
            {renderFilterItem("Ready")}
            {renderFilterItem("Printed")}
            {renderFilterItem("Packed")}
            {renderFilterItem("Scanned")}
          </div>
          {selectedPackages?.size > 0 && activeFilter === "Ready" && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<PrintIcon />}
              onClick={handlePrintLabels}
            >
              Print
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default OrderPackagesHeader;
